module.exports = __webpack_public_path__ + "static/media/marker-img.c6fffc21.svg";